export default __webpack_public_path__ + "static/media/Mastercard.92c5b76a.svg";